const resultList = document.getElementById('resultList');
const showMoreBtn = document.getElementById('moreRead');
// const showLessBtn = document.getElementById("show-less-btn");
// PC版とSP版でinputが2箇所あるので、getElementByIdではなく、querySelectorAll
const searchShimmer = document.getElementById('search-shimmer');
const searchProducts = document.querySelectorAll('#search-product');
const searchPriceStart = document.getElementById('search-price-start');
const searchPriceEnd = document.getElementById('search-price-end');
const searchPriceStartDisplay = document.getElementById(
  'search-price-start-display'
);
const searchPriceEndDisplay = document.getElementById(
  'search-price-end-display'
);
const headerSearchForm = document.querySelector('.header__mega-search form');
const submitQueryBtn = document.getElementById('submit-query');
const sortLowestToHighest = document.getElementById('lowest-to-highest');
const sortHighestToLowest = document.getElementById('highest-to-lowest');
const sortMinPrice = document.getElementById('sort-min-price');
const sortRecommendation = document.getElementById('sort-recommendation');
const sortNewestOrder = document.getElementById('sort-newest-order');
const productCount = document.getElementById('product-count');
const sortBy = document.getElementById('SortBy');
//「選択中の条件」 追加、削除処理
const selectedConditionArea = document.querySelector('.active-facets');
let selectedConditions;
const allConditions = document.querySelectorAll(
  '.facets__disclosure-vertical input'
);

let items;
let searchCategoryQueries = [];
let searchStartPriceQuery = searchPriceStart?.value;
let searchEndPriceQuery = searchPriceEnd?.value;
let currentProducts = null;
/**
 * Stores all the search params for api except title
 */
let searchParams = new URLSearchParams();

/** Start : UI functions */

const showResultList = () => {
  if (!resultList) {
    return;
  }
  resultList.style.display = 'block';
};

const hideResultList = () => {
  if (!resultList) {
    return;
  }
  resultList.style.display = 'none';
};

const showProducts = (rawData = []) => {
  const data = rawData.map((item) => item._source);
  const arrLength = data.length;

  let htmlRow = `<div class="row row-start search-result-items grid product-grid grid--2-col-tablet-down grid--4-col-desktop">`;
  for (let j = 0; j < arrLength; j++) {
    htmlRow += `
      <div class="item col-md-2 col-sm-6 custom-col grid__item card--item">
        <a data-component="product-card" onclick="onProductClick()" 
        href="/products/${data[j].handle}" 
          class="product-card" data-collId="${data[j].handle.split('_')[1]}"
        data-imageURL="${data[j].image_url}"
                data-title="${data[j].title}"
                data-price="${data[j].min_price}"
        >
          <div class="product-card__imagewrap" style="aspect-ratio:1;">
            <img src="${
              data[j].image_url
            }" class="product-card__imagewrap__img" alt="${
      data[j].title
    }" style="aspect-ratio:1;object-fit: cover;">
          </div>
          ${
            data?.[j]?.has_basic_colors && data?.[j]?.handle?.split('_')[1]
              ? `
              <div class="product-card__color-image-container">
                <img style="width:100%; height:100%" height="auto" width="auto"  src="https://cdn.prod.shop.precocirico.com/collections/${
                  data?.[j]?.handle?.split('_')[1]
                }/all_basic_colors.png" />
              </div>
            `
              : ''
          }
          <div class="product-card__content">
            <h3 class="product-card__title">${data[j].title}</h3>

            <div class="price" style="display:flex; justify-content:space-between;">
              <div class="price__container">
                <div class="class="price__regular">
                  <span class="price-item price-item--regular c-font-roboto ${
                    data[j].sale_price ? 'card-price__discount' : ''
                  }">
                    ${new Intl.NumberFormat('ja-JP').format(
                      data[j].min_price
                    )}<span class="small-text">円 (税込)</span>
                    ${
                      data[j].max_price !== data[j].min_price
                        ? '<span class="price-tilde">〜</span>'
                        : ''
                    }
                  </span>
                </div>
              </div>
              <span class="fav-heart__container" onclick="event.preventDefault(); event.stopPropagation();">
              <svg width="25" height="25" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg" >
                <path 
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                  fill="none" stroke="#DDC248">
                </path>
              </svg>
            </span>
            </div>
          </div>
        </a>
      </div>`;
  }
  htmlRow += `</div>`;

  if (resultList) {
    resultList.innerHTML += htmlRow;
  }

  items = document.querySelectorAll('.item');

  // Integrate Product Labels  app filter

  window._Services?.favourite.renderFavForCards();
  if (
    typeof Samita !== 'undefined' &&
    typeof Samita.ProductLabels !== 'undefined'
  ) {
    Samita.ProductLabels.init();
  }
};
const renderShimmer = () => {
  if (searchShimmer) {
    searchShimmer.style.display = 'block';
  }
};

const removeShimmer = () => {
  if (searchShimmer) {
    searchShimmer.style.display = 'none';
  }
};

function updateTotalItemsCount(totalItems) {
  if (productCount) {
    productCount.innerText = totalItems;
  }
}

/**
 * visibility for show more button
 */
function updateShowMoreUI() {
  if (getTotalVisibleCount() < getTotalItemsCount()) {
    showMoreBtn.classList.remove('visibility-hidden');
  } else {
    showMoreBtn.classList.add('visibility-hidden');
  }
}

function updateUIInitial(data) {
  resultList.innerHTML = '';
  updateUI(data);
}

function updateUI(data) {
  updateTotalItemsCount(data.total.value);
  showProducts(data.hits);
  updateShowMoreUI();
}

function displayShowMoreBtn() {
  showMoreBtn.classList.remove('visibility-hidden');
}

function hideShowMoreBtn() {
  showMoreBtn.classList.add('visibility-hidden');
}

/** End : UI functions */

/** Start: Data functions */
const PARAMS_KEY = 'params';
const PREV_URL_KEY = 'prev-url';
const PREV_PREV_URL_KEY = 'prev-prev-url';

function setPrevURLInStorage(prevURL) {
  const [_, prevPrevUrl] = getPrevURLFromStorage();

  sessionStorage.setItem(PREV_PREV_URL_KEY, prevPrevUrl);
  sessionStorage.setItem(PREV_URL_KEY, prevURL);
}

function removePrevURLFromStorage() {
  sessionStorage.removeItem(PREV_PREV_URL_KEY);
  sessionStorage.removeItem(PREV_URL_KEY);
}

function getPrevURLFromStorage() {
  return [
    sessionStorage.getItem(PREV_PREV_URL_KEY) || '',
    sessionStorage.getItem(PREV_URL_KEY) || '',
  ];
}

function setParamsInStorage(params) {
  sessionStorage.setItem(PARAMS_KEY, params?.toString());
}

function getParamsFromStorage() {
  return sessionStorage.getItem(PARAMS_KEY) || '';
}

function removeParamsFromStorage() {
  sessionStorage.removeItem(PARAMS_KEY);
}

function addCurrentProducts(data) {
  if (!data) return;

  if (!currentProducts) {
    currentProducts = {};
  }

  currentProducts.hits = [
    ...(currentProducts?.hits || []),
    ...(data?.hits || []),
  ];
  currentProducts.total = data?.total;
}

function storeCurrentProducts(data) {
  if (!data) {
    return;
  }

  currentProducts = data;
}

function removeCurrentProducts() {
  currentProducts = null;
}

function storeProductDatasInStorage(data) {
  if (!data) return;
  sessionStorage.setItem('productList', JSON.stringify(data));
}

function getProductDatasFromStorage() {
  const data = sessionStorage.getItem('productList');
  return data ? JSON.parse(data) : null;
}

function removeProductDataFromStorage() {
  sessionStorage.removeItem('productList');
}

function storeScrollPos(scrollPos) {
  if (scrollPos === undefined || scrollPos === null) return;

  sessionStorage.setItem('scrollPos', scrollPos);
}

function getScrollPos() {
  return sessionStorage.getItem('scrollPos');
}

function removeScrollPos() {
  sessionStorage.removeItem('scrollPos');
}

function getTotalItemsCount() {
  return Number(productCount?.innerText) || 0;
}

function getTotalVisibleCount() {
  return document.getElementsByClassName('card--item').length;
}
/** End: Data functions */

/** Start: Controller Functions */
let preventURLSave = false;
document.addEventListener('submit', function (event) {
  if (event.target?.id !== 'sui-search-box__form') return;
  preventURLSave = true;
  setPrevURLInStorage('');
});

window.addEventListener('beforeunload', () => {
  if (preventURLSave) return;
  setPrevURLInStorage(window.location.pathname);
});

function onProductClick() {
  storeScrollPos(window.scrollY);
  setParamsInStorage(searchParams);
  storeProductDatasInStorage(currentProducts);
}

/**
 * @returns query params as string
 */
function generateQueryString(searchParams) {
  const title = new URLSearchParams(window.location.search).get('q');
  const newSearchParams = new URLSearchParams(searchParams);

  if (title) {
    newSearchParams.set('title', title);
  }

  return newSearchParams.toString();
}

// initialize category checkboxes,price ranges, sort select and tags.
function initializeConditions() {
  const categories = searchParams.get('category')?.split(',') || [];
  const priceStart = searchParams.get('price_low') || 0;
  const priceEnd = searchParams.get('price_high') || 1_000_000;
  const sortValue = searchParams.get('sort') || 'recommend';

  if (sortValue) {
    const valueToDisplay = {
      recommend: 'sort-recommendation',
      new: 'sort-newest-order',
      low_high: 'lowest-to-highest',
      high_low: 'highest-to-lowest',
    };
    sortBy.value = valueToDisplay[sortValue] || 'sort-recommendation';
  }

  document.querySelectorAll('.price-range-checkbox').forEach((checkbox) => {
    if (
      checkbox.dataset.priceLow === priceLow &&
      checkbox.dataset.priceHigh === priceHigh
    ) {
      checkbox.checked = true;
    }
  });

  if (priceStart) {
    searchPriceStart.value = priceStart;
    searchPriceStartDisplay.textContent = priceStart;
  }

  if (priceEnd) {
    searchPriceEnd.value = priceEnd;
    searchPriceEndDisplay.textContent = priceEnd;
  }

  // make category checkboxes checked
  allConditions.forEach((condition) => {
    if (categories.includes(condition.dataset.condition)) {
      condition.checked = true;
    }
  });

  // selected tags
  allConditions.forEach((condition, idx) => {
    // this is done to ignore one price range. (there are two price ranges.)
    if (idx === allConditions.length - 1) return;

    if (
      condition.checked ||
      (condition.dataset.condition === 'priceRange' && (priceStart || priceEnd))
    ) {
      let selectedConditionValue;
      if (condition.dataset.condition === 'priceRange') {
        selectedConditionValue = `${searchPriceStart.value} - ${searchPriceEnd.value}`;
      } else {
        selectedConditionValue = condition.value;
      }
      addSelectedCondition(condition, selectedConditionValue);

      selectedRemoveButtons = document.querySelectorAll(
        '.active-facets__button-inner svg'
      );

      selectedRemoveButtons.forEach((removeButton) => {
        removeButton.addEventListener('click', () => {
          removeSelectedCondition(removeButton.parentElement); //削除イベントをセット
        });
      });
    }
  });
}

/** End: Controller Functions */

const fetchQueryProducts = async (queryString) => {
  // todo change this
  return fetch(`${baseURL}search/all?${queryString}`)
    .then((res) => res.json())
    .then((productData) => {
      return productData.hits;
    })
    .then((hits) => {
      const searchAfterData = hits?.hits?.[hits?.hits?.length - 1]?.sort || '';
      searchParams.set('search_after', JSON.stringify(searchAfterData));

      return hits;
    })
    .finally(() => {
      removeShimmer();
      showResultList();
    });
};

const handleCategoryChange = (target) => {
  const { checked, value } = target;
  let categories = searchParams.get('category')?.split(',') || [];

  if (checked) {
    categories.push(value);
  } else {
    categories = categories.filter((q) => q !== value);
  }

  searchParams.set('category', categories.join(','));
  searchParams.delete('search_after');

  renderShimmer();
  hideResultList();
  hideShowMoreBtn();
  fetchQueryProducts(generateQueryString(searchParams)).then((data) => {
    storeCurrentProducts(data);
    updateUIInitial(data);
  });
};

const handlePriceChange = (target) => {
  const { checked, dataset } = target;
  const priceLow = dataset.priceLow;
  const priceHigh = dataset.priceHigh;

  // Uncheck all other checkboxes
  document.querySelectorAll('.price-range-checkbox').forEach((checkbox) => {
    if (checkbox !== target) {
      checkbox.checked = false;
    }
  });

  // Remove previous price filters
  searchParams.delete('price_low');
  searchParams.delete('price_high');
  searchParams.delete('search_after');

  // Set the selected price range if checked
  if (checked) {
    searchParams.set('price_low', priceLow);
    if (priceHigh) {
      searchParams.set('price_high', priceHigh);
    }
  }

  renderShimmer();
  hideResultList();
  hideShowMoreBtn();

  fetchQueryProducts(generateQueryString(searchParams)).then((data) => {
    storeCurrentProducts(data);
    updateUIInitial(data);
  });
};

if (window.location.pathname.includes('search')) {
  preventURLSave = false;

  const productDataFromStorage = getProductDatasFromStorage();

  const [prevPrevUrl, prevUrl] = getPrevURLFromStorage();
  if (
    prevPrevUrl.startsWith('/search') &&
    prevUrl.startsWith('/products/collection') &&
    productDataFromStorage
  ) {
    searchParams = new URLSearchParams(getParamsFromStorage());
    storeCurrentProducts(productDataFromStorage);

    updateTotalItemsCount(productDataFromStorage.total?.value || 0);
    initializeConditions();
    updateUIInitial(productDataFromStorage);
    removeShimmer();

    const scrollPos = getScrollPos();
    if (scrollPos) {
      window.scrollTo(0, scrollPos);
    }
  } else {
    searchParams = new URLSearchParams();
    removeCurrentProducts();

    renderShimmer();
    hideResultList();
    hideShowMoreBtn();
    fetchQueryProducts(generateQueryString(searchParams)).then((data) => {
      storeCurrentProducts(data);
      updateUIInitial(data);
    });
  }

  removeParamsFromStorage();
  removeProductDataFromStorage();
}

showMoreBtn?.addEventListener('click', function () {
  renderShimmer();
  hideShowMoreBtn();
  fetchQueryProducts(generateQueryString(searchParams)).then((moreData) => {
    updateUI(moreData);
    addCurrentProducts(moreData);
  });
});

sortBy?.addEventListener('change', function () {
  const selectedValue = this.value;

  const valueMap = {
    'sort-recommendation': 'recommend',
    'sort-newest-order': 'new',
    'lowest-to-highest': 'low_high',
    'highest-to-lowest': 'high_low',
  };

  searchParams.set('sort', valueMap[selectedValue]);
  searchParams.delete('search_after');

  renderShimmer();
  hideResultList();
  hideShowMoreBtn();
  fetchQueryProducts(generateQueryString(searchParams)).then((data) => {
    updateUIInitial(data);
    storeCurrentProducts(data);
  });
});

// Close the dropdown menu if the user clicks outside of it
window.onclick = function (event) {
  if (!event.target.matches('.dropbtn')) {
    let dropdowns = document.getElementsByClassName('dropdown-content');
    let i;
    for (i = 0; i < dropdowns.length; i++) {
      let openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }
};

allConditions.forEach((condition) => {
  //条件クリック時
  condition.addEventListener('change', (e) => {
    const checkCondition = document.querySelector(
      `.active-facets .active-facets__button-inner[data-condition="${condition.dataset.condition}"]`
    );

    if (checkCondition) {
      //選択中の条件 削除処理
      selectedConditionArea.removeChild(checkCondition); //条件削除

      if (condition.dataset.condition === 'priceRange') {
        let selectedConditionValue = `${searchPriceStart.value} - ${searchPriceEnd.value}`;
        addSelectedCondition(condition, selectedConditionValue); //価格変更の場合、条件再追加
      }
    } else {
      //選択中の条件 追加処理
      let selectedConditionValue;
      if (condition.dataset.condition === 'priceRange') {
        selectedConditionValue = `${searchPriceStart.value} - ${searchPriceEnd.value}`;
      } else {
        selectedConditionValue = condition.value;
      }
      addSelectedCondition(condition, selectedConditionValue); //条件追加
    }

    selectedRemoveButtons = document.querySelectorAll(
      '.active-facets__button-inner svg'
    );

    selectedRemoveButtons.forEach((removeButton) => {
      removeButton.addEventListener('click', () => {
        removeSelectedCondition(removeButton.parentElement); //削除イベントをセット
      });
    });
  });
});

//選択条件を追加する
// adds tag in selected condition list
function addSelectedCondition(condition, selectedConditionValue) {
  const addedConditionElm = document.createElement('span');
  if (addedConditionElm) {
    addedConditionElm.className =
      'active-facets__button-inner button button--tertiary';
    addedConditionElm.dataset.condition = condition.dataset.condition;
    addedConditionElm.innerHTML = `
    ${selectedConditionValue}
    <svg
      aria-hidden="true"
      focusable="false"
      width="12"
      height="13"
      class="icon icon-close-small"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;

    selectedConditionArea?.appendChild(addedConditionElm);
  }
}

//選択条件を削除する
function removeSelectedCondition(condition) {
  if (selectedConditionArea.contains(condition)) {
    selectedConditionArea.removeChild(condition); //条件削除
    if (condition.dataset.condition === 'priceRange') {
      searchPriceStart.value = '0';
      searchPriceEnd.value = '1000000';
      handlePriceChange(searchPriceStart);
      handlePriceChange(searchPriceEnd);
    } else {
      const relavantCondition = document.querySelector(
        `.facets__disclosure-vertical input[data-condition="${condition.dataset.condition}"]`
      );
      relavantCondition.checked = false;
      handleCategoryChange(relavantCondition);
    }
  }
}

// suggestion
function autocomplete(input, getSuggestFunction) {
  input.addEventListener('input', function () {
    const value = input.value;
    //Close the existing list if it is open
    closeList();

    //If the input is empty, exit the function
    if (!value) return;

    getSuggestFunction(value).then((list) => {
      closeList();

      if (!list.length) return; // NOTE:該当商品がないときは、suggestの要素を閉じてreturn

      //Create a suggestions <div> and add it to the element containing the input field
      suggestions = document.createElement('div');

      suggestions.setAttribute('id', 'suggestions');
      suggestions.setAttribute(
        'class',
        'sui-search-box__autocomplete-container'
      );

      listElement = document.createElement('ul');

      //Iterate through all entries in the list and find matches
      for (let i = 0; i < list.length; i++) {
        if (list[i].toUpperCase().includes(value.toUpperCase())) {
          //If a match is found, create a suggestion <div> and add it to the suggestions <div>
          suggestion = document.createElement('li');
          suggestion.innerHTML = list[i];

          suggestion.addEventListener('click', function () {
            input.value = this.innerHTML;
            closeList();
          });

          listElement.appendChild(suggestion);
        }
      }

      if (!listElement.children.length) return; // NOTE:if (list[i].toUpperCase().includes(value.toUpperCase()))の条件で、該当商品がないときは return

      suggestions.appendChild(listElement);
      this.parentNode.appendChild(suggestions);
    });
  });

  function closeList() {
    let suggestions = document.getElementById('suggestions');
    if (suggestions) {
      suggestions.parentNode.removeChild(suggestions);
    }
  }
}

const getSuggestTitle = async (inp) => {
  return fetch(`${searchPoint}products/suggest/title?q=${inp}`)
    .then((res) => res.json())
    .then((productData) => {
      const buckets = productData.aggregations.keywords.buckets;
      const keywordList = buckets.map((item) => item.key);

      return keywordList;
    });
};

searchProducts.forEach((searchProduct) =>
  autocomplete(searchProduct, getSuggestTitle)
);
